var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',_vm._g({attrs:{"width":"6","height":"8","fill":"#974900","xmlns":"http://www.w3.org/2000/svg"}},_vm.$listeners),[_c('path',{attrs:{"d":"M.875 6.793l.707.707 3.536-3.536L1.582.43l-.707.707 2.828 2.828L.875 6.793z"}})])}
var staticRenderFns = []

export { render, staticRenderFns }